import React, { useState } from "react";
import "./Loign.scss";

import InputField from "../../ui/InputField/InputField";
import Button from "../../ui/Button/Button";
import { setToken } from "../../utils/token";

import * as api from "../../utils/api";
import * as urls from "../../utils/urls";

export const Login = () => {
  const [state, setState] = useState({
    email: "",
    password: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const { email, password } = state;

  const handleChange = e =>
    setState(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));

  const handleSubmit = () => {
    setIsLoading(true);

    api
      .login(state)
      .then(({ token }) => {
        setToken(token);

        window.location.replace(`/`);
      })
      .catch(() => setHasError(true))
      .finally(() => setIsLoading(false));
  };

  return (
    <div className={"login"}>
      <div className="login__form">
        <div className="login__page-title">Войти</div>
        {hasError && (
          <div style={{ color: "tomato", marginBottom: 12 }}>
            Неверный email или пароль
          </div>
        )}
        <div className="login__fields">
          <div className="login__field">
            <InputField
              label="Логин"
              onChange={handleChange}
              value={email}
              name="email"
              placeholder={"Введите ваш email"}
            />
          </div>
          <div className="login__field">
            <InputField
              label="Пароль"
              onChange={handleChange}
              value={password}
              name="password"
              placeholder={"Введите ваш пароль"}
              htmlType={"password"}
            />
          </div>
        </div>
        <Button onClick={handleSubmit} disabled={isLoading}>
          Войти
        </Button>
      </div>
    </div>
  );
};
